module.exports = __webpack_public_path__ + "img/default-image.1fa5b81b.jpg";